export const reportsMessages = {
  en: {
    reportGenerationFailed: "An error occurred while generating the report, please try again",
    reportGenerationSuccessfully: "The report has been successfully generated",
    reportValidationSuccess: "Report '{0}' has been validated successfully",
    reportValidationError: "Error when validate report '{0}'",
  },
  fr: {
    reportGenerationFailed:
      "Une erreur s'est produite pendant la génération du report veuillez réssayer",
    reportGenerationSuccessfully: "Le rapport a été généré",
    reportValidationSuccess: "Le rapport '{0}' a été validé",
    reportValidationError: "Erreur pendant la validation du rapport '{0}'",
  },
};
